import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useCallback, useContext, useState } from 'react';
export var FormContext = /*#__PURE__*/createContext({
  setFormErrorMessage: function setFormErrorMessage() {},
  enableEditView: undefined
});
var FormContextProvider = function FormContextProvider(_ref) {
  var enableEditView = _ref.enableEditView,
    children = _ref.children;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];

  // Sets the form footer error message
  var setFormErrorMessage = useCallback(function (errorMessage) {
    return setError(errorMessage);
  }, [setError]);
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: {
      setFormErrorMessage: setFormErrorMessage,
      formErrorMessage: error,
      enableEditView: enableEditView
    }
  }, children);
};
var useFormContext = function useFormContext() {
  return useContext(FormContext);
};
export { FormContextProvider, useFormContext };
export var withLinkCreateFormContext = function withLinkCreateFormContext(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(FormContextProvider, null, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
};